import { posthogEvents } from '@/shared/constants/constants';
import { posthogLog } from '@/shared/pinia/modules/posthog/logger';

/**
 * Tracks clicks on category navigation links.
 * Reads `data-track-nav-en` (English name) and `data-track-nav-localized` (localized name)
 * from the clicked element or its closest ancestor with those attributes.
 */
export const initNavigationTracking = () => {
  const navLinks = document.querySelectorAll<HTMLElement>(
    '[data-track-nav-en]'
  );

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const categoryEn = link.dataset.trackNavEn || '';
      const categoryLocalized = link.dataset.trackNavLocalized || '';

      const data = {
        category_name: categoryEn,
        category_localized: categoryLocalized
      };

      posthogLog('navigation_category_clicked', data);
      window.posthog?.capture(posthogEvents.NAVIGATION_CATEGORY_CLICKED, data);
    });
  });
};

/**
 * Tracks clicks on the top marketing banner (sales banner / site alert).
 */
export const initTopBannerTracking = () => {
  const bannerLinks = document.querySelectorAll<HTMLAnchorElement>(
    '[data-track-top-banner]'
  );

  bannerLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const data = {
        banner_text:
          link.dataset.trackTopBannerText ||
          link.textContent?.trim().replace(/\s+/g, ' ') ||
          '',
        banner_url: link.href || ''
      };

      posthogLog('top_banner_clicked', data);
      window.posthog?.capture(posthogEvents.TOP_BANNER_CLICKED, data);
    });
  });
};

/**
 * Tracks clicks on merchandising boxes (grid banner cards).
 */
export const initMerchandisingBoxTracking = () => {
  const boxes = document.querySelectorAll<HTMLElement>(
    '[data-track-merch-box]'
  );

  boxes.forEach((box) => {
    box.addEventListener('click', () => {
      const data = {
        box_title: box.dataset.trackMerchBox || '',
        box_url: box.dataset.trackMerchBoxUrl || '',
        box_position: box.dataset.trackMerchBoxPosition || ''
      };

      posthogLog('merchandising_box_clicked', data);
      window.posthog?.capture(posthogEvents.MERCHANDISING_BOX_CLICKED, data);
    });
  });
};
